import { getApplicationDomain } from '../constants/apiEnvironments';
import { isHubSpotHost } from '../utils/urls';
const getSubpath = () => {
  return '/beta';
};
const getSearch = (redirectUrl, email) => {
  if (!redirectUrl) {
    return '';
  }
  if (!isHubSpotHost(redirectUrl)) {
    return '';
  }
  if (!email) {
    return `?loginRedirectUrl=${encodeURIComponent(redirectUrl)}`;
  }
  return `?loginRedirectUrl=${encodeURIComponent(redirectUrl)}&email=${encodeURIComponent(email)}`;
};
export const getLoginUrl = ({
  redirectUrl,
  email,
  hublet
} = {}) => {
  const subpath = getSubpath();
  const search = getSearch(redirectUrl, email);
  return `${getApplicationDomain(hublet)}/login${subpath}${search}`;
};